import { useHandler } from '../../useHandlerMutation';

export const useUpsertContactIndividual = () =>
  useHandler((api) => api.contact().upsertContactIndividual, {
    invalidates: () => [['MEMBER_SEARCH']],
  });
